<template>
  <div class="mt-4">
    <v-card class="rounded-lg" elevation="6">
      <v-card-title class="indigo--text">
        <v-icon class="mr-2 pink--text">mdi-image</v-icon>
        Photo Promosi
      </v-card-title>
      <v-card-text>
        <v-container class="pa-4 text-center">
          <v-row class="fill-height" align="center" justify="center">
            <v-col
              v-for="(item, i) in itemsFileFiltered"
              :key="i"
              class="d-flex child-flex"
              cols="12"
              sm="6"
              md="6"
              lg="4"
            >
              <template v-if="true">
                <v-hover v-slot="{ hover }">
                  <v-card
                    class="align-self-center"
                    :elevation="hover ? 10 : 0"
                    :class="[
                      { 'on-hover': hover },
                      hover ? 'card-hover-opacity' : 'card-not-hover-opacity',
                    ]"
                  >
                    <div v-if="item.fileType === 'IMAGE'">
                      <v-img
                        :lazy-src="lookupImageUrlLazy(item)"
                        :src="lookupImageUrl(item)"
                      >
                        <v-card-title class="text-h6 white--text fill-height">
                          <v-row
                            class="fill-height flex-column"
                            justify="space-between"
                          >
                            <v-spacer />
                            <div class="align-self-center">
                              <v-btn
                                :class="{ 'show-btns': hover }"
                                :color="transparent"
                                icon
                                large
                                dark
                                outlined
                                @click="deleteDialogShow(item)"
                              >
                                <v-icon
                                  :class="{ 'show-btns': hover }"
                                  :color="transparent"
                                  large
                                >
                                  mdi-delete
                                </v-icon>
                              </v-btn>
                            </div>
                          </v-row>
                        </v-card-title>
                      </v-img>
                    </div>

                    <div
                      v-else-if="item.fileType === 'MP4'"
                      class="justify-center align-center"
                    >
                      <div>
                        <Media
                          :kind="'video'"
                          :isMuted="false"
                          :src="urlMp4File(item)"
                          :controls="true"
                          :autoplay="false"
                          :loop="true"
                          :ref="'fish'"
                          :style="{ width: '250px' }"
                          @pause="handle()"
                        >
                        </Media>
                      </div>

                      <v-btn
                        icon
                        dark
                        outlined
                        @click="deleteDialogShow(item)"
                        color="red"
                      >
                        <v-icon color="red">mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </v-card>
                </v-hover>
              </template>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container class="text-center">
          <v-row>
            <v-col cols="12" sm="7" md="7">
              <v-btn color="primary" block @click="showDialogUpload"
                ><v-icon>mdi-image</v-icon> Photo
              </v-btn>
            </v-col>
            <v-col cols="12" sm="5" md="5">
              <v-btn
                class="white--text"
                color="red"
                block
                @click="showDialogUploadMp4"
                ><v-icon>mdi-video</v-icon> Vidio
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>

    <UploadImageDialog
      ref="refUploadDialog"
      @eventUploadSuccess="completeUploadSuccess"
    ></UploadImageDialog>
    <UploadMp4Dialog
      ref="refUploadDialogMp4"
      @eventUploadSuccess="completeUploadMp4Success"
    ></UploadMp4Dialog>

    <DeleteConfirmDialog
      ref="refDeleteConfirmDialog"
      @eventFromDeleteConfirmDialog1="deleteItemConfirmedSingleSelect"
      @eventFromDeleteConfirmDialog2="deleteItemConfirmedMultiSelect"
    ></DeleteConfirmDialog>

    <v-snackbar v-model="snackbar">
      {{ snackBarMesage }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false"> Close </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
  
<script>
import FileService from "@/services/apiservices-umkm/file-service";
import FUmkmFileService from "@/services/apiservices-umkm/f-umkm-file-service";

import FUmkm from "@/models/umkm/f-umkm";
import UploadImageDialog from "@/components/utils-umkm/UploadImageDialog.vue";
import UploadMp4Dialog from "@/components/utils-umkm/UploadMp4Dialog.vue";
import FUmkmFile from "@/models/umkm/f-umkm-file";
import DeleteConfirmDialog from "@/components/utils/DeleteConfirmDialog.vue";

import Media from "@dongido/vue-viaudio";

export default {
  components: {
    Media,
    UploadMp4Dialog,
    UploadImageDialog,
    DeleteConfirmDialog,
  },
  props: {
    itemModified: new FUmkm(),
    itemsFile: [],
  },
  data() {
    return {
      snackbar: false,
      snackBarMesage: "",

      transparent: "rgba(255, 255, 255, 0)",
      transparent2: "rgba(255, 255, 0, 0)",
    };
  },
  computed: {
    itemsFileFiltered() {
      return this.itemsFile
        .filter(
          (item) =>
            item.jenis === 1 &&
            (item.fileType === "IMAGE" || item.fileType === "MP4")
        )
        .sort((a, b) => a.fileType < b.fileType);
      // return this.itemsFile
    },
  },
  methods: {
    handle() {
      setTimeout(() => {
        this.$refs.fish.play();
      }, 2000);
    },

    showDialogUpload() {
      if (
        this.itemModified.kode1 !== undefined &&
        this.itemModified.description !== undefined &&
        this.itemModified.fdivisionBean !== undefined
      ) {
        this.$refs.refUploadDialog.showDialog();
      } else {
        this.snackBarMesage =
          "Kode, Deskripsi, Divisi harus diisi dahulu";
        this.snackbar = true;
      }
    },

    completeUploadSuccess: function (val) {
      if (val.fileName !== "") {
        let fUmkmFileBean = new FUmkmFile(
            0,
            this.itemModified.id,
            val.fileName,
            val.description,
            1,
            "IMAGE",
            2,
            true,
        );

        fUmkmFileBean.modifiedBy = this.$store.state.auth.user.username;
        FUmkmFileService.createFUmkmFile(fUmkmFileBean).then(
          (response) => {
            this.$refs.refUploadDialog.closeDialog();
            this.$emit("retrieveFiles", response.dummy);
          },
          (error) => {
            console.log(error.message);
          }
        );
      }
    },
    showDialogUploadMp4() {
      if (
        this.itemModified.kode1 !== undefined &&
        this.itemModified.description !== undefined &&
        this.itemModified.fdivisionBean !== undefined
      ) {
        this.$refs.refUploadDialogMp4.showDialog();
      } else {
        this.snackBarMesage =
          "Kode, Deskripsi, Divisi, Desa, Pengembang dan Status harus diisi dahulu";
        this.snackbar = true;
      }
    },
    completeUploadMp4Success: function (val) {
      if (val.fileName !== "") {
        let fUmkmFileBean = new FUmkmFile(
            0,
            this.itemModified.id,
            val.fileName,
            val.description,
            2,
            "MP4",
            4,
            true
        );
        fUmkmFileBean.modifiedBy = this.$store.state.auth.user.username;

        FUmkmFileService.createFUmkmFile(fUmkmFileBean).then(
          (response) => {
            this.$refs.refUploadDialogMp4.closeDialog();
            //Just REfresh files
            this.$emit("retrieveFiles", response.dummy);
          },
          (error) => {
            console.log(error.message);
          }
        );
      }
    },
    urlMp4File(item) {
      return FileService.fileStreamMp4File(item.fileName);
    },

    deleteDialogShow(item) {
      this.itemSelectedIndex = this.itemsFile.indexOf(item);
      this.itemSelected = Object.assign({}, item);
      // this.myConfirmDelete = true
      this.$refs.refDeleteConfirmDialog.showDialog(
        this.itemSelectedIndex,
        item.description
      );
    },

    deleteItemConfirmedSingleSelect(index) {
      console.log("delete SingleItem: " + index);

      const deletedItem = this.itemsFile[this.itemSelectedIndex];
      FUmkmFileService.deleteFUmkmFile(deletedItem.id).then(
        () => {
          this.$emit("retrieveFiles", deletedItem);
          this.closeDialog();
        },
        (error) => {
          console.log(error);
          this.snackBarMesage = "gagal hapus (digunakan oleh data anakk)";
          this.snackbar = true;
          this.$refs.refDeleteConfirmDialog.setDialogState(false);
        }
      );
      FileService.deleteImage(deletedItem.fileName).then(
        () => {
        },
        (error) => {
          console.log(error.response);
        }
      );
    },
    deleteItemConfirmedMultiSelect(items) {
      console.log(items);
    },
    closeDialog() {
      // this.myConfirmDialog = false
      this.formMode = "";
      this.$refs.refDeleteConfirmDialog.setDialogState(false);

      this.$nextTick(() => {
        this.itemSelected = Object.assign({}, new FUmkm());
        this.itemSelectedIndex = -1;
      });
    },

    lookupImageUrl(item) {
      if (item.fileName === undefined) {
        return require("@/assets/images/no_image_available.jpeg");
      } else {
        return FileService.image_url_medium(item.fileName);
      }
    },
    lookupImageUrlLazy(item) {

      return FileService.image_url_low(item.fileName);
    },
  },
};
</script>
  
<style scoped>
.card-hover-opacity {
  opacity: 0.4;
}
.card-not-hover-opacity {
  opacity: 1;
  /*transition: opacity .4s ease-in-out;*/
  transition: opacity 0.4s ease-in-out;
}

.show-btns {
  color: red !important;
  opacity: 1;
}

.show-btns-blue {
  color: blue !important;
  opacity: 1;
}
</style>
  